import { render, staticRenderFns } from "./ProvinceData.vue?vue&type=template&id=7c95b0c0&scoped=true&"
import script from "./ProvinceData.vue?vue&type=script&lang=js&"
export * from "./ProvinceData.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceData.vue?vue&type=style&index=0&id=7c95b0c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95b0c0",
  null
  
)

export default component.exports